import { stringify } from 'query-string';
export var buildUrl = function buildUrl(baseUrl, queryParams) {
  var query = stringify(queryParams);
  return query ? "".concat(baseUrl, "?").concat(stringify(queryParams, {
    encode: false
  })) : baseUrl;
};
export var clearQueryString = function clearQueryString(queryParams) {
  window.history.replaceState(undefined, document.title, buildUrl(window.location.pathname, queryParams));
};